import { render, staticRenderFns } from "./TournamentInfo.vue?vue&type=template&id=9e459c26&scoped=true&"
import script from "./TournamentInfo.vue?vue&type=script&lang=js&"
export * from "./TournamentInfo.vue?vue&type=script&lang=js&"
import style0 from "./TournamentInfo.vue?vue&type=style&index=0&id=9e459c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e459c26",
  null
  
)

export default component.exports